import { useTranslation } from 'react-i18next';
const { CURRENCIES } = require('@arbitrip/constants');

const ExchangeRateInfo = ({ exchangeRate, sourceCoin = CURRENCIES.ILS, targetCoin = CURRENCIES.USD, totalCharge, useHighExchangeRate = false }) => {
  const { t } = useTranslation();

  return (
    <div className="exr-more-info-container">
      <div className="exr-total-charge flex space-between">
        <span>{t('DealDetails.YouWillBeCharged')}</span>
        <span><b>{totalCharge}</b></span>
      </div>

      
      <div className="exr-content">
        <div className="content-title">{t('MoreInfoSection.ContentTitle')}</div>
        <div className="exr">
          {t('MoreInfoSection.ExchangeRateFormat', {
            sourceCoin: sourceCoin,
            targetCoin: targetCoin,
            rate: ( 1 / exchangeRate ).toFixed(4),
          })}
        </div>

        {useHighExchangeRate && <div className="description">{t('MoreInfoSection.FXDisclosure')}</div>}
        <div className="description">{t('MoreInfoSection.Description')}</div>
      </div>
   
    </div>
  );
};

export default ExchangeRateInfo;